// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WdwB","textarea":"styles_textarea__2uztR"};